

import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import CommonSection from '../components/ui/CommonSection/CommonSection'
import '../styles/wallet.css'

const Wallet = () => {

  const wallet_data = [
   {
    title: 'Bitcoin',
    desc: '>Es un hecho establecido hace demasiado tiempo que un lector!',
    icon: 'ri-bit-coin-line'
   },

   {
    title: 'Coinbase',
    desc: '>Es un hecho establecido hace demasiado tiempo que un lector!',
    icon: 'ri-coin-line'
   },
    
   {
    title: 'Metamask',
    desc: '>Es un hecho establecido hace demasiado tiempo que un lector!',
    icon: 'ri-money-cny-circle-line'
   },
    
   {
    title: 'Authreum',
    desc: '>Es un hecho establecido hace demasiado tiempo que un lector!',
    icon: 'ri-bit-coin-line'
   }
    
    
  ]



  return (
    <>
      <CommonSection title='Common Wallet' />

      <section>
        <Container>
          <Row>
            <Col lg='12'  className='mb-5 text-center'>
            <div className='w-50 m-auto'>
            <h3 className='text-light'> Connect your Wallet</h3>
            <p>Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el contenido
            del texto de un sitio mientras que mira su diseño.</p>
            </div>        
            </Col>

            {

              wallet_data.map((item,index) => (
                <Col lg='3' md='4' sm='6' key={index} className='mb-4'>
              <div className='wallet_item'>
              <span><i class={item.icon}></i></span>
              <h5> {item.title}</h5>
              <p>{item.desc}</p>
              </div>
            </Col>
            ))
            }

          </Row>
        </Container>
      </section>
    </>
  )
}

export default Wallet